<template>
	<div class="app-root">
		<div class="dashboard-container">
			<el-form ref="form" :model="form" label-width="80px">
				<el-tabs v-model="activeTab" @tab-click="handleTabClick">
					<el-tab-pane label="话费充值" name="phoneRecharge">
						<el-input v-model="form.phone" placeholder="请输入蜗牛/迪加手机号" :show-word-limit="true" clearable
							type="text" inputmode="numeric"></el-input>
						<div class="list-box">
							<ul>
								<li class="form-list" :class="form.amount == 10 ? 'active' : ''" @click="getAmount('10')">10 元</li>
								<li class="form-list" :class="form.amount == 30 ? 'active' : ''" @click="getAmount('30')">30 元</li>
								<li class="form-list" :class="form.amount == 50 ? 'active' : ''" @click="getAmount('50')">50 元</li>
								<li class="form-list" :class="form.amount == 100 ? 'active' : ''" @click="getAmount('100')">100 元</li>
								<li class="form-list" :class="form.amount == 150 ? 'active' : ''" @click="getAmount('150')">150 元</li>
								<li class="form-list" :class="form.amount == 200 ? 'active' : ''" @click="getAmount('200')">200 元</li>
								<li class="form-list" :class="form.amount == 300 ? 'active' : ''" @click="getAmount('300')">300 元</li>
								<li class="form-list" :class="form.amount == 500 ? 'active' : ''" @click="getAmount('500')">500 元</li>
								<el-input v-model="amount" placeholder="其他金额" show-word-limit="true" style="width: 30%;margin: 10px 0;"
									type="text" inputmode="numeric" @change="getAmount2" @input="handleInput"></el-input>
							</ul>
						</div>
						<div style="width: 100%;clear: both;font-size: 12px;color: #ff0000;margin-left: 20px;margin-bottom: 20px;">
							温馨提示：充值前请核对号码信息无误，充值后将无法退款!</div>
						<el-button @click="onSubmit()"
							style="margin: 0 5%;color: #fff;background-color: #4dbd21;border-color: #4dbd21;width: 90%;border-radius: 30px;height: 48px;">
							立即充值
						</el-button>
						<div class="ad_box"><img src="https://images.10000.work/ad.jpg" alt="" /></div>
					</el-tab-pane>
					<el-tab-pane label="套餐充值" name="packageRecharge">
						<div class="package-recharge">
							<el-input v-model="packageForm.phone" placeholder="请输入手机号码" :show-word-limit="true" clearable
								type="text" inputmode="numeric" style="margin-bottom: 20px;"></el-input>
							<el-button type="primary" @click="queryPackage" style="width: 100%;margin-bottom: 20px;">
								查询套餐
							</el-button>
							<div v-if="packageInfo" class="package-info">
								<div class="info-item">
									<span class="label">号码状态：</span>
									<span class="value" :class="packageInfo.state === '待激活' ? 'status-warn' : 'status-normal'">{{ packageInfo.state }}</span>
								</div>
								<div class="info-item">
									<span class="label">套餐名称：</span>
									<span class="value">{{ packageInfo.ORDER_NAME }}</span>
								</div>
<!--						<div class="info-item">-->
<!--							<span class="label">账户余额：</span>-->
<!--							<span class="value">{{ packageInfo.REAL_BALANCE }}元</span>-->
<!--						</div>-->
								<div class="info-item" v-if="packageInfo.packageAmount !== undefined">
								<span class="label">套餐金额：</span>
								<span class="value price-highlight">{{ packageInfo.packageAmount }}元</span>
							</div>
							<div class="info-item" v-if="packageInfo.actualRechargeAmount !== null && packageInfo.actualRechargeAmount !== undefined">
								<span class="label">实际充值金额：</span>
								<span class="value price-highlight">{{ packageInfo.actualRechargeAmount }}元</span>
							</div>
								<div class="info-item" v-if="packageInfo.currentYearMonth">
									<span class="label">本月套餐：</span>
									<span class="value" :class="packageInfo.hasCurrentMonthRecord ? 'status-normal' : 'status-warn'">
										{{ packageInfo.currentYearMonth }} {{ packageInfo.currentMonthText || (packageInfo.hasCurrentMonthRecord ? '已充值' : '未充值') }}
									</span>
								</div>
								<div class="info-item" v-if="packageInfo.nextYearMonth">
									<span class="label">次月套餐：</span>
									<span class="value" :class="packageInfo.hasNextMonthRecord ? 'status-normal' : 'status-warn'">
										{{ packageInfo.nextYearMonth }} {{ packageInfo.hasNextMonthRecord ? '已充值' : '未充值' }}
									</span>
								</div>
								<div class="info-item" v-if="packageInfo.rechargeTip">
									<span class="label">充值提示：</span>
									<span class="value" :class="packageInfo.canRecharge ? 'status-normal' : 'status-warn'">{{ packageInfo.rechargeTip }}</span>
								</div>
								<el-button type="success" @click="submitPackageRecharge" style="width: 100%;margin-top: 20px;" :disabled="!packageInfo.canRecharge">
									{{ packageInfo.canRecharge ? (packageInfo.thisMon ? '充值本月套餐' : '充值次月套餐') : '不可充值' }}
								</el-button>
							</div>
							<div v-else class="no-data">
								请输入手机号码查询套餐信息
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-form>
 			<div class="history-btn" @click="toHistoricalOrders">查看历史订单</div>
 		</div>
 		<el-dialog title="充值确认" v-model="packageRechargeVisible" width="80%" @close="closePackageRecharge" :close-on-click-modal="false">
			<div class="package-recharge-dialog">

				<div class="amount-list">
<!--        <div class="amount-item">-->
<!--          <span class="amount-label">当前余额</span>-->
<!--          <span class="amount-value">{{ packageInfo?.REAL_BALANCE }}元</span>-->
<!--        </div>-->
				<div class="amount-item">
					<span class="amount-label">套餐金额</span>
					<span class="amount-value">{{ packageInfo?.packageAmount }}元</span>
				</div>
				<div class="amount-item">
					<span class="amount-label">套餐周期</span>
					<span class="amount-value">{{ packageRechargeMonth }}</span>
				</div>
				<div class="amount-item highlight">
					<span class="amount-label">实际充值金额</span>
					<span class="amount-value">{{ packageRechargeAmount }}元</span>
				</div>


				</div>
			  <div class="dialog-tip">
				<el-icon class="el-icon-warning" style="color: #e6a23c; font-size: 24px; margin-right: 8px;"></el-icon>
<!--        <span>为避免余额不足停机，套餐充值金额需在标准资费基础上多充 2 元</span>-->
				<span style="color: red;">为避免余额不足停机，套餐充值金额需在标准资费基础上多充 2 元</span>
			  </div>
				<div class="dialog-actions">
					<el-button @click="closePackageRecharge" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmPackageRecharge" size="medium">确认充值</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- <el-dialog title="历史订单" v-model="upload" width="80%" @close="closeUpload()" :close-on-click-modal="false">
			<ul>
				<li class="dialog-list" v-for="item in ordersList" :key="item.orderId">
					<div class="below">
						<span>{{ item.userPhone }}</span>
						<span>{{ item.orderAmount }}元</span>
						<span>{{ item.shippingType }}</span>
					</div>
					<div class="top">
						<span>{{ item.status }}</span>
						<span>{{ item.time }}</span>
					</div>
				</li>
			</ul>
		</el-dialog> -->
		<el-dialog title="充值提示" v-model="errorDialogVisible" width="85%" :close-on-click-modal="false" :show-close="true">
			<div class="error-dialog-content">
				<div class="error-icon">
					<i class="el-icon-warning" style="color: #e6a23c; font-size: 48px;"></i>
				</div>
				<div class="error-message">{{ errorMessage }}</div>
				<div class="error-tip">如需充值次月套餐(月租) 请点击页面顶部右侧"套餐充值"</div>
			</div>
			<template v-slot:footer>
				<span class="dialog-footer">
					<el-button type="primary" @click="errorDialogVisible = false" style="width: 100%;">我知道了</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	// 判断是否为微信环境
	const isWechat = () => {
		return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger';
	};
	import { getXmInfo, queryXmOrders, getOpenId, getPhonePackageInfo, publicAccountPackageTopUp } from '../api/index.js';
	import { wx } from 'weixin-js-sdk';
	export default {
		data() {
			return {
				activeTab: 'phoneRecharge',
				form: {
					amount: '',
					phone: ''
				},
				packageForm: {
					phone: ''
				},
				packageInfo: null,
				code: '',
				amount: '',
				lastValidValue: '',
				upload: false,
				ordersList: [],
				openId: '',
				packageRechargeVisible: false,
				packageRechargeAmount: 0,
				packageRechargeMonth: '',
				errorDialogVisible: false,
				errorMessage: ''
			};
		},

		created() {
			this.getWechatCode();
			// 检查 URL 是否带有 phone 参数（从话费充值页面跳转过来）
			const urlParams = this.getUrlCode();
			if (urlParams.phone) {
				this.packageForm.phone = urlParams.phone;
				this.activeTab = 'packageRecharge';
				// 等待 DOM 更新后自动查询
				this.$nextTick(() => {
					this.queryPackage();
				});
			}
		},
		methods: {
			getWechatCode() {
				if (isWechat) {
					let appid = 'wx68b0128d62be2a7a'; //微信APPid
					this.code = this.getUrlCode().code; //是否存在code
					let local = 'http://topup.10000.work';
					if (this.code == null || this.code === '') {
						window.location.href =
							'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
							appid +
							'&redirect_uri=' +
							encodeURIComponent(local) +
							'&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect';
					}
				}
			},

			getAmount(e) {
				this.form.amount = e;
				this.amount = '';
			},
			getAmount2(e) {
				this.form.amount = e;
			},
			handleInput(value) {
				const regex = /^[1-9]\d*$/;
				if (!regex.test(value)) {
					this.amount = this.lastValidValue;
				} else {
					this.lastValidValue = value;
				}
			},
			toHistoricalOrders() {
				localStorage.setItem('code', this.code);
				this.$router.push('/orderList');
			},

			getUrlCode() {
				// 截取url中的code方法
				var url = location.search;
				var theRequest = new Object();
				if (url.indexOf('?') != -1) {
					var str = url.substr(1);
					var strs = str.split('&');
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
					}
				}
				return theRequest;
			},
			onSubmit() {
				if (this.form.phone == '') {
					this.$message.error('请输入需要充值的手机号');
				} else if (this.form.amount == '') {
					this.$message.error('请输入需要充值的金额');
				} else {
					this.form.code = this.code;
					this.form.openId = this.openId;
					getXmInfo(this.form).then(res => {
						if (res.code == 200) {
							localStorage.setItem('openid', res.data.openid);
							this.openId = res.data.openid;
							window.WeixinJSBridge.invoke(
								'getBrandWCPayRequest', {
									appId: res.data.appid, //公众号名称，由商户传入
									timeStamp: res.data.timestamp, //时间戳，自1970年以来的秒数
									nonceStr: res.data.noncestr, //随机串
									package: res.data.prepayid,
									signType: res.data.type, //微信签名方式：
									paySign: res.data.sign //微信签名
								},
								function(res) {
									console.log(res, '我是调起支付后的');
									if (res.code == 500) {
										this.$message.error(res.message);
									}
									// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
									if (res.err_msg == 'get_brand_wcpay_request:ok') {
										//支付成功
										// if (that.query().fromPage) {
										// 	that.$router.push({
										// 		path: that.query().fromPage
										// 	});
										// } else {
										// 	that.$router.push({
										// 		path: '/mobile/subresult'
										// 	});
										// }
									} else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
										//取消支付的操作
										// if (that.query().fromPage) {
										// 	that.$router.push({
										// 		path: that.query().fromPage
										// 	});
										// } else {
										// 	that.$router.push({
										// 		path: '/mobile/dailyorder',
										// 		query: {
										// 			skuId: that.query().skuId
										// 		}
										// 	});
										// }
										//取消支付
									} else {
										//支付失败
										// if (that.query().fromPage) {
										// 	that.$router.push({
										// 		path: that.query().fromPage
										// 	});
										// } else {
										// 	that.$router.push({
										// 		path: '/mobile/dailyorder',
										// 		query: {
										// 			skuId: that.query().skuId
										// 		}
										// 	});
										// }
									}
								}
							);
						} else {
					// 检查是否需要跳转到套餐充值
					if (res.data && res.data.needPackageTopUp) {
						this.$message.warning('号码未激活，请先购买套餐');
						// 切换到套餐充值 tab
						this.activeTab = 'packageRecharge';
						this.packageForm.phone = res.data.phone || this.form.phone;
						this.$nextTick(() => {
							this.queryPackage();
						});
					} else {
						this.errorMessage = res.message || '充值失败';
						this.errorDialogVisible = true;
					}
				}
					});
				}
			},
			handleTabClick(tab) {
				console.log('切换到标签页:', tab.name);
			},
			queryPackage() {
				if (!this.packageForm.phone) {
					this.$message.error('请输入手机号码');
					return;
				}
				getPhonePackageInfo(this.packageForm.phone).then(res => {
					if (res?.code === 200) {
						this.packageInfo = res.data;
						this.$message.success('查询成功');
					} else {
						this.packageInfo = null;
						this.$message.error(res.message || '查询失败');
					}
				}).catch(err => {
					this.packageInfo = null;
					this.$message.error('查询失败，请稍后再试');
					console.error(err);
				});
			},
			submitPackageRecharge() {
			if (!this.packageInfo) {
				this.$message.error('请先查询套餐信息');
				return;
			}
			if (!this.packageInfo.ORDER_NAME) {
				this.$message.error('套餐信息异常');
				return;
			}
			if (!this.packageInfo.actualRechargeAmount) {
				this.$message.error(this.packageInfo.rechargeTip || '套餐金额异常');
				return;
			}

			// 直接使用后端返回的实际充值金额，前端不参与计算
			this.packageRechargeAmount = this.packageInfo.actualRechargeAmount;

			const today = new Date();
			let targetDate;
			if (this.packageInfo.thisMon) {
				targetDate = today;
			} else {
				targetDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
			}
			const year = targetDate.getFullYear();
			const month = String(targetDate.getMonth() + 1).padStart(2, '0');
			this.packageRechargeMonth = `${year}-${month}`;

			this.packageRechargeVisible = true;
		},
			confirmPackageRecharge() {
				this.packageRechargeVisible = false;
				const param = {
					code: this.code,
					phone: this.packageForm.phone,
					actualRechargeAmount: this.packageRechargeAmount,
					openId: this.openId,
					thisMonth: this.packageInfo.thisMon,
					packagesId: this.packageInfo.packagesId,
					half: this.packageInfo.half,
					needIntercept: this.packageInfo.needIntercept
				};
				// publicAccountPackageTopUp(param).then(res =&gt; {
				publicAccountPackageTopUp(param).then(res => {
					if (res?.code === 200) {
						localStorage.setItem('openid', res.data.openid);
						this.openId = res.data.openid;
						window.WeixinJSBridge.invoke(
							'getBrandWCPayRequest', {
								appId: res.data.appid,
								timeStamp: res.data.timestamp,
								nonceStr: res.data.noncestr,
								package: res.data.prepayid,
								signType: res.data.type,
								paySign: res.data.sign
							},
							function(res) {
								console.log(res, '套餐充值支付回调');
								if (res.code == 500) {
									this.$message.error(res.message);
								}
								if (res.err_msg == 'get_brand_wcpay_request:ok') {
									this.$message.success('支付成功');
								} else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
									this.$message.info('已取消支付');
								} else {
									this.$message.error('支付失败');
								}
							}
						);
					} else {
						this.$message.error(res.message || '支付失败');
					}
				}).catch(err => {
					this.$message.error('支付失败，请稍后再试');
					console.error(err);
				});
			},
			closePackageRecharge() {
				this.packageRechargeVisible = false;
			},
		}
	};
</script>

<style scoped>
	.dashboard-container {
 		padding: 15px 15px 80px 15px;
 		min-height: 100vh;
 		box-sizing: border-box;
 		position: relative;
 	}

 	.history-btn {
 		width: 100%;
 		text-align: center;
 		padding: 20px 0;
 		color: #999;
 		cursor: pointer;
 		font-size: 14px;
 		margin-top: 10px;
 	}

	.list-box {
		width: 100%;
		margin: 20px 2%;
	}

	.form-list {
		width: 30%;
		border: 1px solid #ececec;
		border-radius: 8px;
		height: 56px;
		text-align: center;
		margin: 10px 2% 10px 0;
		float: left;
		line-height: 56px;
	}

	/deep/.el-input__inner {
		height: 60px;
		font-size: 1.6rem;
		color: #323232;
	}

	.el-input.is-active .el-input__inner,
	.el-input__inner:focus {
		border-color: #b9fbb6;
	}

	.list-box /deep/.el-input__inner {
		height: 56px;
	}

	.list-box .active {
		border: 1px solid #3dbf15;
		color: #3dbf15;
		background: #d7f1ce;
	}

	.ad_box {
		width: 90%;
		margin: 20px 5%;
	}

	.ad_box img {
		width: 100%;
	}

	.package-recharge {
		padding: 20px 0;
	}

	.package-info {
		background: #f5f5f5;
		padding: 20px;
		border-radius: 8px;
	}

	.info-item {
		display: flex;
		margin-bottom: 15px;
	}

	.info-item .label {
		width: 120px;
		color: #666;
	}

	.info-item .value {
		flex: 1;
		color: #333;
		font-weight: 500;
	}

	.no-data {
		text-align: center;
		color: #999;
		padding: 40px 0;
	}

	.status-warn {
		color: #ff6600;
		font-weight: bold;
	}

	.status-normal {
		color: #3dbf15;
		font-weight: bold;
	}

	.price-highlight {
		color: #ff0000;
		font-size: 18px;
		font-weight: bold;
	}

	/deep/.el-tabs__header {
		margin: 0 0 25px 0;
	}

	/deep/.el-tabs__item {
		font-size: 18px;
		height: 50px;
		line-height: 50px;
		padding: 0 25px;
	}

	.package-recharge-dialog {
		padding: 20px 0;
	}

	.dialog-tip {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 25px;
		color: #666;
		font-size: 15px;
	}

	.amount-list {
		background: #f8f9fa;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 25px;
	}

	.amount-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #e9ecef;
	}

	.amount-item:last-child {
		border-bottom: none;
	}

	.amount-item.highlight {
		padding-top: 18px;
	}

	.amount-label {
		color: #666;
		font-size: 15px;
	}

	.amount-value {
		color: #333;
		font-size: 16px;
		font-weight: 500;
	}

	.amount-item.highlight .amount-label {
		color: #333;
		font-weight: 600;
		font-size: 16px;
	}

	.amount-item.highlight .amount-value {
		color: #ff4d4f;
		font-size: 20px;
		font-weight: bold;
	}

	.dialog-actions {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}

	.error-dialog-content {
		text-align: center;
		padding: 10px 0 20px;
	}

	.error-icon {
		margin-bottom: 15px;
	}

	.error-message {
		font-size: 16px;
		color: #333;
		margin-bottom: 20px;
		line-height: 1.6;
	}

	.error-tip {
		font-size: 14px;
		color: #ff0000;
		background: #fff2f0;
		border: 1px solid #ffccc7;
		border-radius: 6px;
		padding: 12px 16px;
		line-height: 1.6;
	}
</style>